import {LOG_OUT, IW_MODULES, IW_VIDEOS, IW_STATUS} from "./ActionTypes";
import {getUser} from "../utils/TokenManager";
import IWService from "../services/InstallationWizardService";

const logOutSuccess = () => ({type: LOG_OUT});

const setIWModules = (data) => ({
    type: IW_MODULES,
    modules: data
});

const setIWVideos = (data) => ({
    type: IW_VIDEOS,
    videos: data
});

const setIWStatus = (status) => ({
    type: IW_STATUS,
    status: status
});


export const getIWModules = (locationId) => (
    async (dispatch) => {
        try {
            const result = await IWService.getIWModules(locationId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                dispatch(setIWModules(result.data));
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);


export const getIWVideos = (iwId) => (
    async (dispatch) => {
        try {
            const result = await IWService.getIWVideos(iwId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                dispatch(setIWVideos(result.data));
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);


export const updateIWVideos = (videoObj, videosList) => (
    async (dispatch) => {
        try {
            const result = await IWService.updateIwVideoDetails(videoObj.id, videoObj);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            
            if (200 === result.status) {
                let newVideosList = videosList.map(video => {
                    if (video.id === videoObj.id) {
                        return {...result.data};
                    }
                    return {...video};
                });
                dispatch(setIWVideos(newVideosList));
                return newVideosList;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const updateIWSetting = (iwObj, iwModuleList) => (
    async (dispatch) => {
        try {
            const result = await IWService.updateIwSetting(iwObj.id, iwObj);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                let newModuleList = iwModuleList.map(moduleObj => {
                    if (moduleObj.id === iwObj.id) {
                        return {...result.data};
                    }
                    return {...moduleObj};
                });
                dispatch(setIWModules(newModuleList));
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);


export const getIwStatus = (locationId) => (
    async (dispatch) => {
        try {
            const result = await IWService.getIwStatus(locationId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                let is_completed = result.data.is_installation_completed;
                if (is_completed) {
                    dispatch(setIWStatus(result.data.is_installation_completed));
                    return true;
                }
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const updateRollOut = (locationId, rollOutObj) => (
    async (dispatch) => {
        try {
            const result = await IWService.updateRollOut(locationId, rollOutObj);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getRollOut = (locationId) => (
    async (dispatch) => {
        try {
            const result = await IWService.getRollOut(locationId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const autocompleteModule = (iwObj, iwModuleList) => (
    async (dispatch) => {
        try {
            const result = await IWService.autocompleteModule(iwObj.id);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                let updatedModuleObj = {
                    ...iwObj, 
                    is_completed: result.data.is_completed,
                    is_in_progress: result.data.is_in_progress
                };
                let newModuleList = iwModuleList.map(moduleObj => {
                    if (moduleObj.id === iwObj.id) {
                        return {...updatedModuleObj};
                    }
                    return {...moduleObj};
                });
                dispatch(setIWModules(newModuleList));
                return updatedModuleObj;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/InstallationWizardAction.js